import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { Pool } from '../../../../apis/pool.api';
import { P00030InstallationFinish } from './P00030/Installation/P00030InstallationFinish';
import { P00030InstallationReset } from './P00030/Installation/P00030InstallationReset';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00030CardTAirStatutComponent } from './P00030/TAir/cards/p00030-card-tair-statut/p00030-card-tair-statut.component';
import { P00030TairStatusComponent } from './P00030/TAir/cps/p00030-tair-status/p00030-tair-status.component';
import { P00032Alarm } from './P00032/Alarm/P00032Alarm';
import { P00030Alarm } from './P00030/Alarm/P00030Alarm';

export class P00030Data {
  taIAjustementTemperature: number = 0;

  taIConfigurationProduit: number = 0;

  taSMesureBrutTemperature: number = 0;

  taSMesureTemperature: number = 0;

  taSTensionPile: number = 0;

  taSCompteurResetUsine: number = 0;

  taSEtatPile: number = 0;

  taSAlarme: number = 0;

  taCResetUsine: number = 0;
}

export class P00030 extends IProduct {
  override deviceTableIndex: number = 6;

  override modelIdentifier?: string = 'P00030';

  override dataIdentifier?: string = 'P00030';

  override manufacturerName?: string = 'SiliconLabs';

  data: P00030Data = new P00030Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00030/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00030/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00030/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00030;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00030?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00030.tuto.installation.help.title',
      helpSlides: [
        'P00030.tuto.installation.help.1',
        'P00030.tuto.installation.help.2',
        'P00030.tuto.installation.help.3',
        'P00030.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00030/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00030/installation-1_dark.png',
          },
          text: 'P00030.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00030/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00030/installation-2_dark.png',
          },
          text: 'P00030.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00030/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00030/installation-1_dark.png',
          },
          text: 'P00030.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00030/update-2.png',
            dark: '/assets/ecosystem/images/products/P00030/update-2_dark.png',
          },
          text: 'P00030.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [],
        finish: P00030InstallationFinish,
        reset: P00030InstallationReset,
      },
      controlCards: [],

      alarms: {
        weight: 2,
        component: P00030Alarm,
      },

      statusCards: [{ component: P00030CardTAirStatutComponent, weight: 4 }],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.MEASURE];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.TAIR ||
      functionnality == EventProductFunctionnalityEnum.MEASURE
    ) {
      return {
        miseEnOeuvre: {
          pages: [],
        },
        controle: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        parametrages: {
          enabledUser: false,
          enabledSupport: false,

          reglage: {
            enabledUser: false,
            enabledSupport: false,
            component: null,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00030TairStatusComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00030.history.temperature',
                mode: HistoryGraphModeEnum.DATA,
                property: 'taSMesureTemperature',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                chartMode: HistoryChartModeEnum.LINEAR,
                yModeOptions: { min: -100, max: 500 },
                showDirectly: true,
              },
              {
                title: 'P00030.history.batteryVoltage',
                mode: HistoryGraphModeEnum.DATA,
                property: 'taSTensionPile',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.VOLT_MILLIEME,
                chartMode: HistoryChartModeEnum.LINEAR,
                yModeOptions: { min: 0, max: 3000 },
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return null;
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).taIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
